import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaBullseye,
  FaEye,
  FaHeart,
  FaUsers,
  FaBolt,
  FaGlobe,
  FaUserFriends,
  FaAward,
  FaCheckCircle
} from "react-icons/fa";

const About = () => {
  return (
    <div style={{ background: "#f5f7fa" }}>

      {/* ================= HERO SECTION ================= */}
      <section style={{ padding: "70px 0" }}>
        <Container>
          <Row className="align-items-center px-5">
            
            {/* LEFT */}
            <Col md={6}>
              <span className="text-uppercase text-muted small">About Us</span>
              
              <h1 className="fw-bold mt-2">
                About <span style={{ color: "#0d6efd" }}>Skills Uprise</span>
              </h1>

              <p className="text-muted mt-3">
                Skills Uprise is a premier ed-tech platform empowering students with the
                skills they need to thrive. We provide hands-on training, industry
                mentorship, and recognized certifications.
              </p>
            </Col>

            {/* RIGHT IMAGE */}
            <Col md={6}>
              <img
                src="	https://skillsuprise.com//static/media/gobal-certificate.3c2d058a.webp"
                alt="about"
                style={{
                  width: "100%",
                  borderRadius: "15px",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* ================= WHAT DRIVES US ================= */}
      <section className="py-3">
        <Container>
          <h2 className="text-center fw-bold mb-5">What Drives Us</h2>

          <Row className="g-4">
            
            {[
              {
                icon: <FaBullseye />,
                title: "Our Mission",
                text: "To bridge the gap between academic learning and industry requirements through practical training."
              },
              {
                icon: <FaEye />,
                title: "Our Vision",
                text: "To become the leading platform for skill development and industry-ready training across India."
              },
              {
                icon: <FaHeart />,
                title: "Our Values",
                text: "Innovation, integrity, inclusivity, and a relentless focus on student success."
              },
              {
                icon: <FaUsers />,
                title: "Our Community",
                text: "5,000+ alumni working across top companies in India and abroad."
              }
            ].map((item, i) => (
              <Col md={3} key={i}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="text-center">
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "12px",
                        background: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 15px",
                        color: "#0d6efd",
                        fontSize: "20px"
                      }}
                    >
                      {item.icon}
                    </div>

                    <h6 className="fw-bold">{item.title}</h6>
                    <p className="text-muted small">{item.text}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* ================= OUR JOURNEY ================= */}
      <section className="py-3 bg-light">
        <Container>
          <h2 className="text-center fw-bold mb-5">Our Journey</h2>

          <Row className="text-center g-4">
            
            {[
              { icon: <FaBolt />, year: "2019", text: "Founded in Hyderabad" },
              { icon: <FaGlobe />, year: "2020", text: "Launched online training" },
              { icon: <FaUserFriends />, year: "2022", text: "1,000+ students placed" },
              { icon: <FaAward />, year: "2024", text: "Exam portal launched" }
            ].map((item, i) => (
              <Col md={3} key={i}>
                <div>
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "15px",
                      background: "#e3f2fd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 15px",
                      color: "#0d6efd",
                      fontSize: "22px"
                    }}
                  >
                    {item.icon}
                  </div>

                  <h5 className="fw-bold text-primary">{item.year}</h5>
                  <p className="text-muted small">{item.text}</p>
                </div>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="py-5">
  <Container>
    <Row className="align-items-center justify-content-center gx-5">
      
      {/* IMAGE */}
      <Col md={5} className="text-center mb-4 mb-md-0">
        <img
          src="https://test-bloom-pro.lovable.app/assets/training-corporate-B_gSu7su.jpg"
          alt="why choose us"
          style={{
            width: "100%",
            // maxWidth: "450px",
            height: "350px",
            objectFit: "cover",
            borderRadius: "15px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
          }}
        />
      </Col>

      {/* CONTENT */}
      <Col md={6}>
        <h2 className="fw-bold mb-4 text-center text-md-start">
          Why Choose Us?
        </h2>

        {[
          "100% placement assistance",
          "Industry-relevant curriculum updated quarterly",
          "Live project experience with real clients",
          "Flexible learning – online & offline modes",
          "Affordable pricing with EMI options",
          "Dedicated career counseling team"
        ].map((point, i) => (
          <div key={i} className="d-flex align-items-start mb-3">
            <FaCheckCircle className="text-primary mt-1 me-2" />
            <span>{point}</span>
          </div>
        ))}
      </Col>

    </Row>
  </Container>
</section>

    </div>
  );
};

export default About;